export default __webpack_public_path__ + "static/media/photo--lg--75.3b22a2db.jpg";